export const attachmentProcessingStatus = {
  PENDING: ':pending',
  TRANSCODING: ':transcoding',
  TRANSCODING_COMPLETE: ':transcoding-complete',
  ERROR: ':error'
}

export const boardPermissionLevels = {
  PRIVATE: ':private',
  PUBLIC: ':public'
}

export const topicRequirement = {
  REQUIRED: ':required',
  SUGGESTED: ':suggested',
  OPTIONAL: ':optional'
}

export const invitationStatus = {
  PENDING: ':invitation/pending',
  ACCEPTED: ':invitation/accepted',
  REJECTED: ':invitation/rejected'
}

export const invitationPermissions = {
  ADMIN: ':admin',
  GUEST: ':guest'
}

export const notificationStatus = {
  UNREAD: ':unread',
  ACKNOWLEDGED: ':acknowledged'
}

export const notificationSettingsDefaults = {
  ':post': true,
  ':reply': true,
  ':comment-reply': true,
  ':reaction': true,
  ':mention': true,
  ':new-friend': true,
  ':new-message-thread': true,
  ':direct-message': true,
  ':nudge': true,
  ':join-request': true
}

export const allowedBoardNotificationTypes = [
  ':post',
  ':reply',
  ':comment-reply',
  ':reaction',
  ':mention',
  ':join-request',
  ':friend-post',
  ':nudge'
]

export const notificationSettingsDescriptions = {
  ':post': `someone posts in a community I follow`,
  ':reply': 'someone replies to my post',
  ':comment-reply': 'someone replies to my comment',
  ':reaction': 'someone reacts to my post',
  ':mention': 'someone @mentions me in a post',
  ':new-friend': 'someone follows me',
  ':friend-post': 'someone I follow posts in a community I can view',
  ':new-message-thread': 'someone creates a new message thread with me',
  ':direct-message': 'someone sends me a direct message',
  ':nudge': 'I have been inactive in a community',
  ':join-request': 'I receive community join requests'
}

export const defaultResetForWeeklyMaxedPoints = {
  resetDay: 1,
  resetHour: 8,
  resetTimezone: '-08:00'
}

export const dayOfTheWeek = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 }
]

export const reportPostCategory = [
  { label: 'Inappropriate', value: ':inappropriate' },
  { label: 'Off Topic', value: ':offtopic' },
  { label: 'Plagiarism', value: ':plagiarism' },
  { label: 'Worrisome', value: ':worrisome' },
  { label: 'Other', value: ':other' }
]

export const mimeToCategory = {
  'audio/wav': 'audio',
  'audio/mpeg': 'audio',
  'audio/mp3': 'audio',
  'audio/x-m4a': 'audio',
  'image/png': 'img',
  'image/jpeg': 'img',
  'image/webp': 'img',
  'image/tiff': 'img',
  'image/heic': 'img',
  'image/svg+xml': 'img',
  'video/quicktime': 'video',
  'video/mp4': 'video',
  'video/webm': 'video',
  video: 'video',
  'text/csv': 'file',
  'text/plain': 'file',
  'application/zip': 'file',
  'application/msword': 'doc',
  'application/vnd.ms-powerpoint': 'doc',
  'application/pdf': 'doc',
  'application/vnd.ms-excel': 'file',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'doc',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'doc'
}

export const mimeToType = {
  'audio/mpeg': 'MP3',
  'audio/wav': 'WAV',
  'audio/mp3': 'MP3',
  'audio/x-m4a': 'M4A',
  'image/png': 'PNG',
  'image/jpeg': 'JPEG',
  'image/webp': 'WEBP',
  'image/tiff': 'TIFF',
  'image/heic': 'HEIC',
  'image/svg+xml': 'SVG',
  'image/vnd.microsoft.icon': 'ICO',
  'image/gif': 'GIF',
  'video/quicktime': 'Quicktime',
  'video/mp4': 'MP4',
  'video/webm': 'WEBM',
  'text/plain': 'TXT',
  'application/zip': 'ZIP',
  'application/msword': 'DOC',
  'application/vnd.ms-powerpoint': 'PPT',
  'application/pdf': 'PDF',
  'application/json': 'JSON',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'DOC',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'PPT'
}

export const pointsReportTableCutoffSize = 500

export const skinColorMap = {
  2: '1F3FB',
  3: '1F3FC',
  4: '1F3FD',
  5: '1F3FE',
  6: '1F3FF'
}
